export default __webpack_public_path__ + "static/media/2649.cea9fac3.png";